import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./config";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // null = loading, false = unauth, object = user
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(false);
      return null;
    }
  }, []);

  useEffect(() => {
    // CRITICAL: if returning from Emergent OAuth callback, skip /auth/me here.
    // AuthCallback component handles the session_id exchange first.
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setUser(null);
      return;
    }
    refresh();
  }, [refresh]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, refresh, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
